module.exports = __webpack_public_path__ + "img/nao.027bc3ea.svg";